/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const sparseSegmentRemoteLookupSchema = z.any();

export const sparseSegmentRemoteLookupIdSchema = common.objectId;

export const sparseSegmentRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string(),
  is_archived: z.boolean(),
  is_global_control: z.boolean(),
  is_user_defined: z.boolean(),
  is_non_retargetable: z.boolean(),
  contains_segment_membership: z.boolean(),
  estimated_size: z.int().nullable(),
});

export const sparseSegmentRemoteLookupFiltersSchema = z.object({
  exclude_contains_segment_membership: z.boolean().nullable().optional(),
  only_user_defined: z.boolean().nullable().optional(),
});

export const sparseSegmentRemoteLookupValidators = {
  id: sparseSegmentRemoteLookupIdSchema,
  item: sparseSegmentRemoteLookupItemSchema,
  filters: sparseSegmentRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: dfd76d5cead4cfe7529ca985e6ed3870 */
